import SimpleSignUpTopPage from 'features/membership/components/simple/SimpleSignupTopPage';
import { TEMPLATE_ALIAS_CODE } from 'features/membership/libs/const/aliasCode';
import {
  membershipPluginPageTemplateOptionState,
  SimplePageTemplateOptionKey
} from 'features/membership/libs/recoil/selector';
import { PageTemplateOption } from 'features/membership/types';
import { FC } from 'react';
import { useRecoilValue } from 'recoil';

/**
 * 会員登録トップ
 */
const PepperSignupTop: FC = () => {
  const templateOptions = useRecoilValue<
    Record<SimplePageTemplateOptionKey, PageTemplateOption> | undefined
  >(membershipPluginPageTemplateOptionState(TEMPLATE_ALIAS_CODE.PEPPER));

  return (
    <SimpleSignUpTopPage
      templateAliasCode={TEMPLATE_ALIAS_CODE.PEPPER}
      templateOptions={templateOptions}
    />
  );
};

export default PepperSignupTop;
